import type { Configuration } from '@gov-nx/api/configuration/configuration.types';
import { currentPlatform } from '@gov-nx/utils/common/Platform/platform';
import { CurrentPlatformType } from '@gov-nx/utils/common/Platform/platform.types';

export const getPoServerUrl = (configuration?: Configuration) => {
	// return 'https://poc.asseco-ce.com'
	// return 'http://localhost:3000'
	if (configuration?.poServerUrl) {
		const { poServerUrl } = configuration;
		if (poServerUrl && poServerUrl.indexOf('|') !== -1) {
			const urls = poServerUrl.split('|');
			if (currentPlatform === CurrentPlatformType.IOS) {
				return urls[0] as string;
			} else if (currentPlatform === CurrentPlatformType.ANDROID) {
				return urls[1] as string;
			}
		}
		return poServerUrl as string;
	}
	return null;
};
